<bic-popup (close)="cancelClicked()" customClass="w-[560px]" title="Koordinationsmodell bearbeiten">
  <div bicPopupContent class="flex flex-col gap-4">
    <span class="text-sm text-gray-500">IFC-Dateien für dieses Koordinationsmodell auswählen</span>
    <div class="flex flex-col gap-1 max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-2">
      @for (file of data.ifcFiles; track file.id) {
        <div (click)="toggleFile(file.id)"
             class="flex items-center gap-3 px-2 py-1.5 rounded hover:bg-gray-50 cursor-pointer">
          <input (click)="$event.stopPropagation(); toggleFile(file.id)" [checked]="isSelected(file.id)"
                 class="w-4 h-4 rounded text-green-600 checked:bg-green focus:ring-0"
                 type="checkbox">
          <span class="text-sm text-gray-700 truncate">{{ file.name }}</span>
        </div>
      }
      @if (data.ifcFiles.length === 0) {
        <span class="text-sm text-gray-400 px-2 py-1.5">Keine IFC-Dateien im Projekt vorhanden.</span>
      }
    </div>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    <bic-button (onClick)="cancelClicked()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="saveClicked()" [disabled]="selectedIds.size < 1">Speichern</bic-button>
  </div>
</bic-popup>

